<app-page-header
  [iconType]="'Transaction'"
  [text]="'Transactions'"
></app-page-header>

<app-filterable-table
  #transactionsTable
  [tableView]="tableView"
  [options]="tableOptions"
  (selectedRecord)="handleTransactionSelected($event)"
></app-filterable-table>
